import { NavBar } from "./Navbar";
import { useState } from "react";
import { TextField, Button, Chip } from "@mui/material";
import { req } from "./ServerUtils";

export function ChangeAudience() {
    const [audiences, setAudiences] = useState([]);
    const [audience, setAudience] = useState('');

    function updateServer() {
        req('/related-ideas/update-audience', 'POST', {
            audiences: audiences
        });
    }

    return (
        <>
            <NavBar />
            <div style={{
                paddingTop: 30,
                maxWidth: 800,
                margin: '0 auto'
            }}>
                <div>
                    <h2>Change Audience for Post Recommendations:</h2>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                    marginBottom: 20
                }}>
                    <TextField fullWidth label="Audience" value={audience} onChange={(e) => setAudience(e.target.value)} onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            setAudiences([...audiences, audience]);
                            setAudience('');
                            updateServer();
                        }
                    }}/>
                    <Button variant="contained" fullWidth onClick={() => {
                        setAudiences([...audiences, audience]);
                        setAudience('');
                        updateServer();
                    }}>Add Audience</Button>
                </div>
                <div>
                    {audiences.map((a) => (
                        <div key={a} style={{
                            padding: 10,
                        }}>
                            <Chip style={{
                                borderRadius: 4,
                                padding: "1rem",
                                fontSize: "1rem",
                            }} label={a} onDelete={() => {
                                setAudiences(audiences.filter((del) => del !== a));
                                updateServer();
                            }} />
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}